import { CheckCircleOutlined } from '@ant-design/icons';
import successSVG from '@/static/images/success.svg';
import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { StudyInfoType } from '@/types/camp/study/studentBaseInfoType';
import { useLocalStorageState } from 'ahooks';

const EntrySuccessModal = ({ studentBaseInfo }: { studentBaseInfo?: StudyInfoType | null }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [regSuccess, setRegSuccess] = useLocalStorageState<string[]>('reg_success');
  useEffect(() => {
    if (
      studentBaseInfo?.batchId &&
      studentBaseInfo.signUp &&
      !regSuccess?.includes(studentBaseInfo.batchId)
    ) {
      setIsModalOpen(true);
      setRegSuccess((prev) => [...(prev || []), studentBaseInfo.batchId]);
    }
  }, [studentBaseInfo?.batchId]);

  return (
    <Modal
      open={isModalOpen}
      centered
      width={440}
      onCancel={() => {
        setIsModalOpen(false);
      }}
      footer={null}
    >
      <div className="flex_4_1" style={{ gap: 16, padding: '16px 0' }}>
        <div className="flex_1 f18">
          <CheckCircleOutlined className="col52c f20" style={{ marginRight: 6 }} />
          <span>打卡营报名成功</span>
        </div>
        {studentBaseInfo?.batch.qrCode ? (
          <>
            <div>
              <img src={studentBaseInfo?.batch.qrCode} width={200} height={200} />
            </div>
            <div className="col808 f16">微信「扫一扫」加入学习交流群</div>
          </>
        ) : (
          <div>
            <img src={successSVG} width={200} height={200} />
          </div>
        )}

        <div
          className="com_camp_btn"
          style={{ width: 240, height: 40 }}
          onClick={() => {
            setIsModalOpen(false);
          }}
        >
          我知道了
        </div>
      </div>
    </Modal>
  );
};

export default EntrySuccessModal;
